import { render } from "./ActivePhysicians.vue?vue&type=template&id=f171b32a"
import script from "./ActivePhysicians.vue?vue&type=script&lang=js"
export * from "./ActivePhysicians.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/physicians/ActivePhysicians.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f171b32a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f171b32a', __exports__)) {
    console.log('reload')
    api.reload('f171b32a', __exports__)
  }
  
  module.hot.accept("./ActivePhysicians.vue?vue&type=template&id=f171b32a", () => {
    console.log('re-render')
    api.rerender('f171b32a', render)
  })

}


export default __exports__